import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { startSessionKeepAlive } from "./services/http/session-refresh";
import "./styles/globals.css";

// C2: renew the access token shortly before it expires while the app is open.
startSessionKeepAlive();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
